import './ui/account-statement.scss'
import { AccountStatement as AccountStatementUI } from './ui/account-statement'
import { createAccountStatementContainer } from './container'

export const AccountStatement = createAccountStatementContainer(AccountStatementUI)
